const API_BASE = process.env.REACT_APP_API_URL || '';
const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';

// ===== DEMO MOCK DATA =====
const DEMO_EVENT = {
  id: 'demo-event-id',
  slug: 'demo',
  name: 'Nunta Cristina & Ștefan',
  date: '2025-06-15',
  couple_names: 'Cristina & Ștefan',
  event_type: 'wedding',
  description: 'Împarte-ne cele mai frumoase momente surprinse de tine! Încarcă pozele și clipurile tale din această zi specială.',
  cover_color: '#1a1a2e',
  accent_color: '#c9a96e',
  is_active: 1,
  public_gallery: 1,
  upload_count: 5,
  welcome_title: null,
  welcome_audio: null,
  auto_close_days: null,
};

const DEMO_GALLERY = {
  files: [
    { id: '1', url: '/demo/poza1.jpg', thumbnail_url: '/demo/poza1.jpg', file_type: 'image', uploader_name: 'Maria', message: '', uploaded_at: '2025-06-15T20:00:00' },
    { id: '2', url: '/demo/poza2.jpg', thumbnail_url: '/demo/poza2.jpg', file_type: 'image', uploader_name: 'Alexandru', message: '', uploaded_at: '2025-06-15T20:05:00' },
    { id: '3', url: '/demo/poza3.jpg', thumbnail_url: '/demo/poza3.jpg', file_type: 'image', uploader_name: 'Elena', message: '', uploaded_at: '2025-06-15T20:10:00' },
    { id: '4', url: '/demo/poza4.jpg', thumbnail_url: '/demo/poza4.jpg', file_type: 'image', uploader_name: 'Andrei', message: '', uploaded_at: '2025-06-15T20:15:00' },
    { id: '5', url: '/demo/poza5.jpg', thumbnail_url: '/demo/poza5.jpg', file_type: 'image', uploader_name: 'Cristina', message: '', uploaded_at: '2025-06-15T20:20:00' },
  ],
  total: 5,
  page: 1,
  pages: 1,
};

export const api = {
  async fetch(endpoint, options = {}) {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      headers: { 'Content-Type': 'application/json', ...options.headers },
      ...options,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(err.error || 'Request failed');
    }
    return res.json();
  },

  createEvent: (data) => api.fetch('/api/events', { method: 'POST', body: JSON.stringify(data) }),
  getEvent: (slug) => {
    if (DEMO_MODE) return Promise.resolve(DEMO_EVENT);
    return api.fetch(`/api/events/${slug}`);
  },
  updateEvent: (slug, data) => api.fetch(`/api/events/${slug}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteEvent: (slug, admin_password) => api.fetch(`/api/events/${slug}`, { method: 'DELETE', body: JSON.stringify({ admin_password }) }),
  authEvent: (slug, admin_password) => api.fetch(`/api/events/${slug}/auth`, { method: 'POST', body: JSON.stringify({ admin_password }) }),
  getAdminEvents: (admin_password) => api.fetch('/api/admin/events', { method: 'POST', body: JSON.stringify({ admin_password }) }),

  getGallery: (slug, page = 1) => {
    if (DEMO_MODE) return Promise.resolve(DEMO_GALLERY);
    return api.fetch(`/api/events/${slug}/gallery?page=${page}&limit=50`);
  },
  deleteUpload: (uploadId, admin_password) => api.fetch(`/api/uploads/${uploadId}`, { method: 'DELETE', body: JSON.stringify({ admin_password }) }),

  getSlideshow: (slug, since = '') => api.fetch(`/api/events/${slug}/slideshow${since ? `?since=${encodeURIComponent(since)}` : ''}`),

  getGuestbook: (slug) => {
    if (DEMO_MODE) return Promise.resolve({ welcome_audio_url: null, welcome_title: null, messages: [] });
    return api.fetch(`/api/events/${slug}/guestbook`);
  },
  deleteWelcomeAudio: (slug, admin_password) => api.fetch(`/api/events/${slug}/welcome-audio`, { method: 'DELETE', body: JSON.stringify({ admin_password }) }),

  async uploadWelcomeAudio(slug, file, adminPassword) {
    const formData = new FormData();
    formData.append('audio', file);
    formData.append('admin_password', adminPassword);
    const res = await fetch(`${API_BASE}/api/events/${slug}/welcome-audio`, { method: 'POST', body: formData });
    if (!res.ok) throw new Error('Upload failed');
    return res.json();
  },

  async uploadAudio(slug, audioBlob, uploaderName) {
    if (DEMO_MODE) throw new Error('DEMO_MODE');
    const formData = new FormData();
    formData.append('audio', audioBlob, 'voice_message.webm');
    if (uploaderName) formData.append('uploader_name', uploaderName);
    const res = await fetch(`${API_BASE}/api/events/${slug}/guestbook`, { method: 'POST', body: formData });
    if (!res.ok) throw new Error('Upload failed');
    return res.json();
  },

  async uploadFiles(slug, files, uploaderName, message, onProgress) {
    if (DEMO_MODE) throw new Error('DEMO_MODE');
    const formData = new FormData();
    files.forEach(f => formData.append('files', f));
    if (uploaderName) formData.append('uploader_name', uploaderName);
    if (message) formData.append('message', message);

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${API_BASE}/api/events/${slug}/upload`);
      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable && onProgress) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      });
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject(new Error('Upload failed'));
        }
      };
      xhr.onerror = () => reject(new Error('Upload failed'));
      xhr.send(formData);
    });
  },

  getQRCodeUrl: (slug, format = 'png') => `${API_BASE}/api/events/${slug}/qrcode?format=${format}`,

  async downloadAll(slug, admin_password) {
    const res = await fetch(`${API_BASE}/api/events/${slug}/download`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ admin_password }),
    });
    if (!res.ok) throw new Error('Download failed');
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${slug}_photos.zip`;
    a.click();
    URL.revokeObjectURL(url);
  },

  getFileUrl: (path) => `${API_BASE}${path}`,
};

export default api;
